import { config } from "@/config";
export class ProveedorService {
    static getHeaders() {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        };
    }
    static async getAll(page = 1, search = "", letter = "") {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (search)
            params.append("search", search);
        if (letter)
            params.append("letter", letter);
        const response = await fetch(`${config.API_URL}/api/Proveedor?${params.toString()}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener la lista de proveedores");
        return response.json();
    }
    static async getById(id) {
        const response = await fetch(`${config.API_URL}/api/Proveedor/${id}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener el proveedor");
        return response.json();
    }
    static async buscarPorDocumento(tipoDocId, numero) {
        const response = await fetch(`${config.API_URL}/api/Proveedor/buscar?tipoDocId=${tipoDocId}&numero=${encodeURIComponent(numero)}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok && response.status !== 404) {
            throw new Error("Error en la búsqueda de documento");
        }
        return response.json();
    }
    static async addProveedor(proveedor) {
        const response = await fetch(`${config.API_URL}/api/Proveedor`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify(proveedor),
        });
        if (!response.ok)
            throw new Error("Error al registrar proveedor");
        return response.json();
    }
    static async updateProveedor(id, proveedor) {
        const response = await fetch(`${config.API_URL}/api/Proveedor/${id}`, {
            method: "PUT",
            headers: this.getHeaders(),
            body: JSON.stringify(proveedor),
        });
        if (!response.ok)
            throw new Error("Error al actualizar proveedor");
        return response.json();
    }
    static async deleteProveedor(id) {
        const response = await fetch(`${config.API_URL}/api/Proveedor/${id}`, {
            method: "DELETE",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al deshabilitar proveedor");
        return response.json();
    }
    static async toggleActivo(id) {
        const response = await fetch(`${config.API_URL}/api/Proveedor/${id}/activo`, {
            method: "PUT",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al cambiar estado del proveedor");
        return response.json();
    }
    static async getOrigenes() {
        const response = await fetch(`${config.API_URL}/api/Proveedor/origenes`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener orígenes");
        return response.json();
    }
    static async getTipos() {
        const response = await fetch(`${config.API_URL}/api/Proveedor/tipos`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener tipos");
        return response.json();
    }
    // Métodos para InstrumentoPagoProveedor
    static async getInstrumentos(proveedorId) {
        const response = await fetch(`${config.API_URL}/api/InstrumentoPagoProveedor/proveedor/${proveedorId}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener instrumentos de pago del proveedor");
        return response.json();
    }
    static async addInstrumento(instrumento) {
        const response = await fetch(`${config.API_URL}/api/InstrumentoPagoProveedor`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify(instrumento),
        });
        if (!response.ok)
            throw new Error("Error al registrar instrumento de pago");
        return response.json();
    }
    static async updateInstrumento(id, instrumento) {
        const response = await fetch(`${config.API_URL}/api/InstrumentoPagoProveedor/${id}`, {
            method: "PUT",
            headers: this.getHeaders(),
            body: JSON.stringify(instrumento),
        });
        if (!response.ok)
            throw new Error("Error al actualizar instrumento de pago");
        return response.json();
    }
    static async deleteInstrumento(id) {
        const response = await fetch(`${config.API_URL}/api/InstrumentoPagoProveedor/${id}`, {
            method: "DELETE",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al eliminar instrumento de pago");
        return response.json();
    }
    static async toggleActivoInstrumento(id) {
        const response = await fetch(`${config.API_URL}/api/InstrumentoPagoProveedor/${id}/toggle`, {
            method: "PUT",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al cambiar estado del instrumento");
        return response.json();
    }
}
